import { useSelector } from "react-redux";
import { SubmitType } from "../../types/type";
import { selectAmendmentModalOne } from "../../features/actuarial/request-amendment/request-amendment.slice";
import { useModalAccess } from "../../components/global/modal/use-modal-access";

export function useModalInfo(submitType: SubmitType | null) {

    const { isUpdateProposal } = useModalAccess()
    const amendmentModalOne = useSelector(selectAmendmentModalOne);

    const isRequestAmend = amendmentModalOne === "isRequesting";
    const isDraftAction = submitType === "draft";

    const modalTitle = isRequestAmend
        ? "Request Amendment"
        : isDraftAction
            ? isUpdateProposal
                ? "Save Updated Draft Proposal"
                : "Save Draft Proposal"
            : isUpdateProposal
                ? "Submit Updated Proposal"
                : "Submit Proposal";

    const modalSubTitle = isRequestAmend
        ? "Do you want to submit the updated proposal?"
        : isDraftAction
            ? isUpdateProposal
                ? "Do you want to submit the updated proposal as draft?"
                : "Do you want to submit the proposal as draft?"
            : isUpdateProposal
                ? "Do you want to submit the updated proposal?"
                : "Do you want to submit the proposal?";

    return { modalTitle, modalSubTitle };
}